import { useTheme } from "../theme/ThemeProvider";
import { cn } from "./ui/cn";

interface LoadingScreenProps {
  message?: string;
  hint?: string;
  fullscreen?: boolean;
  className?: string;
}

export function LoadingScreen({
  message = "Carregando",
  hint,
  fullscreen = true,
  className,
}: LoadingScreenProps) {
  const { resolved } = useTheme();
  const icon = resolved === 'dark' ? '/faviconWhite.svg' : '/faviconBlack.svg';
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-6",
        fullscreen ? "min-h-screen min-h-dvh" : "min-h-[40vh] min-h-[40dvh] py-16",
        className,
      )}
    >
      <img src={icon} alt="OTG" className="size-20 object-contain" />

      <div className="flex flex-col items-center gap-2">
        <div className="flex items-baseline gap-[0.08em] text-3xl">
          <span className="font-sora font-extrabold tracking-tight text-ink">
            OTG
          </span>
          <span className="font-jetbrains font-normal text-ink-muted">
            tracker
          </span>
        </div>
        <p className="flex items-center gap-1.5 text-sm text-ink-muted">
          {message}
          <LoadingDots />
        </p>
        {hint && (
          <p className="text-xs text-ink-subtle max-w-xs text-center">{hint}</p>
        )}
      </div>
    </div>
  );
}

function LoadingDots() {
  return (
    <span className="inline-flex items-end gap-0.5 -mb-0.5">
      <span
        className="inline-block size-1 rounded-full bg-brand-500"
        style={{
          animation: "tm-dot 1.2s ease-in-out infinite",
          animationDelay: "0ms",
        }}
      />
      <span
        className="inline-block size-1 rounded-full bg-brand-500"
        style={{
          animation: "tm-dot 1.2s ease-in-out infinite",
          animationDelay: "160ms",
        }}
      />
      <span
        className="inline-block size-1 rounded-full bg-brand-500"
        style={{
          animation: "tm-dot 1.2s ease-in-out infinite",
          animationDelay: "320ms",
        }}
      />
      <style>{`@keyframes tm-dot{0%,80%,100%{transform:translateY(0);opacity:.3}40%{transform:translateY(-3px);opacity:1}}`}</style>
    </span>
  );
}
